import { preferenceConstants } from "../actions/constants/preferenceConstants";

const initialGetState = {
    isLoading: false,
    isSuccess: false,
    isError: false,
    preferenceData: null
};

const initialSaveState = {
    isLoading: false,
    isSuccess: false,
    isError: false,
    preferenceData: null
};

const initialGetByPhoneState = {
    isLoading: false,
    isSuccess: false,
    isError: false,
    preferenceData: null
};

export const getPreferenceReducer = (state = initialGetState, action: any) => {
    switch (action.type) {
        case preferenceConstants.getPreferenceRequest:
            return {
                ...state,
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case preferenceConstants.getPreferenceSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                preferenceData: action.payload
            }
        case preferenceConstants.getPreferenceFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const getPreferenceByPhoneReducer = (state = initialGetByPhoneState, action: any) => {
    switch (action.type) {
        case preferenceConstants.getPreferenceByPhoneRequest:
            return {
                ...state,
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case preferenceConstants.getPreferenceByPhoneSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                preferenceData: action.payload
            }
        case preferenceConstants.getPreferenceByPhoneFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const savePreferenceReducer = (state = initialSaveState, action: any) => {
    switch (action.type) {
        case preferenceConstants.savePreferenceRequest:
            return {
                ...state,
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case preferenceConstants.savePreferenceSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                preferenceData: action.payload
            }
        case preferenceConstants.savePreferenceFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}
